// Generated with tools/create-component.js
import React, { useEffect } from "react";
import { CmsContent, Container } from "components";
import { InfoListQueryFragment } from "codegen";
import "./InfoList.scss";
import AOS from "aos";
import "aos/dist/aos.css";
import classNames from "classnames";

interface InfoListProps {
  data: InfoListQueryFragment;
}

export const InfoList: React.FC<InfoListProps> = ({ data: { description, list } }): JSX.Element => {
  return (
    <Container
      className={classNames({
        "info-list": true,
        "layout--medium": true,
        "section--small": true,
      })}
    >
      <div className="column column--description" data-aos="fade-right">
        <div className="column__content">{description && <CmsContent content={description} />}</div>
      </div>
      <div className="column" data-aos="fade-left">
        {list && <CmsContent content={list} />}
      </div>
    </Container>
  );
};
